import React from "react"
import PropTypes from "prop-types"
import { styled } from '@mui/material/styles'

const UserSummaryCardContainer = styled('div')`
  &.card {
    width: 150px;
    position: fixed;
    display: inline-block;
    top: 346px;
    margin: 0 0 0 20px;
    padding: 10px;
    border-radius: 5px;
    @media (max-width: 1330px) {
      display: none;
    }
  }
`

const AvatarCircle = styled('img')`
  width: 100px;
  height: 100px;
  border: solid 2px black;
`

const AvatarContainer = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const CardTitle = styled('p')`
  margin: 10px 0;
  font-size: 24px;
  line-height: 30px;
`

const StatsList = styled('ul')`
  color: #555;
  i {
    margin-right: 4px;
  }
`

class UserSummaryCard extends React.Component {
  render () {
    const { totalPlaysCount, totalDownloadsCount, avatarUrl, displayName, totalFavoritesCount, totalCreditsEarned } = this.props;
    return (
      <UserSummaryCardContainer className="card">
        <AvatarContainer>
          <AvatarCircle src={avatarUrl} className="circle" />
          <div className="flow-text">{displayName}</div>
        </AvatarContainer>
        <CardTitle className="bold">Uploaded Sample Stats</CardTitle>
        <StatsList>
          <li><i className="fas fa-play" aria-hidden="true"></i> {totalPlaysCount.toLocaleString()}</li>
          <li><i className="fas fa-download" aria-hidden="true"></i> {totalDownloadsCount.toLocaleString()}</li>
          <li><i className="fas fa-heart" aria-hidden="true"></i> {totalFavoritesCount.toLocaleString()}</li>
          <li><i className="fas fa-plus-circle" aria-hidden="true"></i> {totalCreditsEarned.toLocaleString()} credits</li>
        </StatsList>
      </UserSummaryCardContainer>
    );
  }
}

UserSummaryCard.propTypes = {
  playsCount: PropTypes.number,
  downloadsCount: PropTypes.number,
  avatarUrl: PropTypes.string,
  displayName: PropTypes.string,
  favoritesCount: PropTypes.number,
  creditsEarned: PropTypes.number
};
export default UserSummaryCard
